<template>
  <!-- 在el-button的type基础上增加了两个类型，write和delete类型，write为写入权限，delete为删除权限，此类型可以关联到系统读写权限 -->
  <span :id="id" :class="`table-button ${elType} access-${accessDisabled || disabled}`"   :style="{color: color? color:''}"><span @click="clickEvent"><slot></slot></span></span>
</template>

<script>
import {ElMessageBox} from 'element-plus';
import {getCurrentInstance} from "vue";
import ButtonRight from "./ButtonRight";
import {useRoute, useRouter} from "vue-router";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  props: {
    // 提示消息，如果有消息，将阻止点击事件
    message: {default: ""},
    // 可用参数 查询      新建      删除      修改       审批       反审批      导入   导出   批量删除         过账        批量过账         打印
    // 1      "read"， "write", "delete", "update", "check", "checkBack", "im", "ex", "batchDelete", "account", "batchAccount", "print"
    type: {default: ""},
    stopPop: {default: true}, // 阻止冒泡事件
    // 填写多个时，权重越低的权限会覆盖权重高的权限
    // 按钮权限 具有某一种权限才能够访问    权重：0
    hasPerm: {default: ""},
    // 某权限组权限，具有任意某组权限才能够访问   权重：1
    hasAnyPerms: {default: ""},
    // 某权限组权限，具有所有某组权限才能够访问（指同一菜单下的多权限校验，如果是跨菜单。则直接为false）  权重：2
    hasAllPerms: {default: ""},



    elType: {default: "primary"},
    color: {default: ""},
    disabled: {default: false},
  },
  components: {
  },
  data() {
    return {
      accessDisabled: false,
      id: "",
    };
  },
  created() {
    this.id = "table_button" + (Math.random()*9999).toFixed(0);
    const ins = getCurrentInstance();
    if (!this.hasPerm && !this.hasAnyPerms && !this.hasAllPerms) { // 没有设置权限
      this.register2Parent(ins);
      return;
    }
    ButtonRight.buttonHasRight(this.hasPerm, this.hasAnyPerms, this.hasAllPerms, this).then(canAccess => {
      // 这个按钮，是否有授权
      this.accessDisabled = !canAccess;
      this.register2Parent(ins);
    })
  },
  methods: {
    // 注册到上级组件
    register2Parent(ins) {
      // 获取slot中的文本
      if (ins && ins.slots.default) {
        const slotContent = ins.slots.default();
        // 有对应的对象
        if (slotContent.length === 1 && typeof slotContent[0].children === "string") {
          // 如果有上级，进行group注册
          if (this.$parent.addButton) {
            this.$parent.addButton({id: this.id, label: slotContent[0].children, button: this, elType: this.elType, disabled: this.accessDisabled || this.disabled});
          }
        }
      }
    },
    clickEvent(event) {
      if (event && this.stopPop) {
        event.stopPropagation();
      }
      // 权限被禁用
      if (this.accessDisabled || this.disabled) {
        let message = "您没有权限进行此操作，或此数据暂时不支持这个操作，请联系管理人员";
        this.$message.warning(message)
        return;
      }
      if (this.message) {
        ElMessageBox.confirm(this.message, "提示", {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$emit("click", event);
        }).catch(() => {
          this.$emit("cancel", event);
        })
      } else {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-button{
  margin-right: 10px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  //font-weight: 600;
}
.table-button:last-child{
  margin-right: 0;
}
.primary{
  color: #409EFF;
}
.danger{
  color: #F56C6C;
}
.write{
  color: #409EFF;
}
.delete{
  color: #F56C6C;
}
.success{
  color: #67C23A;
}
.warning{
  color: #E6A23C;
}
.access-true{
  color: #999;
}
</style>